/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setShippingLocations} from '../api'

export const useMutationSetShippingLocations = createReactQueryMutationHook('setShippingLocations', setShippingLocations)
